import { IFoMonAnChiTiet } from "../../../models/response/thuc-don/IFoMonAnChiTiet";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objMonAnChiTietDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: [] as IFoMonAnChiTiet[],
    LOAD_ERROR: "",
    LOAD_COSO_START: 0,
    LOAD_COSO_SUCCESS: [] as IFoMonAnChiTiet[],
    LOAD_COSO_ERROR: "",
    SHOW_EDIT_MODAL: {} as IFoMonAnChiTiet | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IFoMonAnChiTiet,
    SAVE_SUCESS: {} as IFoMonAnChiTiet,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: "",
    SHOW_IMPORT_MODAL: undefined,
    CLOSE_IMPORT_MODAL: undefined,
};

export const eFoMonAnChiTietActionTypeIds = generateActionTypeIds(objMonAnChiTietDefine, "MON_AN_CHI_TIET")
export type IFoMonAnChiTietActionTypes = IGenericActionType<typeof objMonAnChiTietDefine, "MON_AN_CHI_TIET">
